import { render, staticRenderFns } from "./RegistrationRequestChecklist.vue?vue&type=template&id=103b2da4"
import script from "./RegistrationRequestChecklist.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports